import axios from "../utils/apiClient";
import {dataFetchHelper} from "./baseDataFetch";
import {PRINT_URL, SUMMARY_URL} from "../views/quickList/QuickList";
import {PREVENTIVE_CARE_COUNT_URL} from "../views/patientProfile/Overview";
import {AppPropertiesUtil} from "../utils/localStorageUtil";


const [
  getPatientProfileOverview,
  useGetPatientProfileOverview,
] = dataFetchHelper(([patientId]) => {
  const featureFlagPatientProfile=AppPropertiesUtil.get("ms.patient-profile.enabled");
  const sanitizedPatientId = encodeURIComponent(patientId);
  if(featureFlagPatientProfile)
    
    return axios.get(
      `${process.env.REACT_APP_REST_API_MS_SERVER}/v2/patient-profile-service/findById?patientId=${sanitizedPatientId}`,
    {
      headers: {},
    }
  )
  else
    return axios.get(
        `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patients/overview?patientId=${sanitizedPatientId}`,
        {
          headers: {},
        }
    );
});

export const getPatientOverview = (patientId) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patients/overview?patientId=${sanitizedPatientId}`,
    {
      headers: {},
    }
  );
}

const [
  getPatientProfileOverviewTabHeaderCount,
  useGetPatientProfileOverviewTabHeaderCount,
] = dataFetchHelper(([patientId]) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  return axios.get(
      `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patients/overview/tab-header-count?patientId=${sanitizedPatientId}`,
      {
        headers: {},
      }
  );
});

const updatePatientProfileOverview = (paitentProfileOverview) => {
  const sanitizedId = encodeURIComponent(paitentProfileOverview.id);
  return axios.post(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patients/update?id=${sanitizedId}`,
    paitentProfileOverview,
    {
      headers: {},
    }
  );
};
const patientInformationSection = (patientId) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  return axios.get(
      `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-quick-view/care-paths?patientId=${sanitizedPatientId}`,
      {
        headers: {},
      }
  );
};

const [
  getPatientProfileRecentActivity,
  useGetPatientProfileRecentActivity,
] = dataFetchHelper(([patientId]) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patients/recent-activity?patientId=${sanitizedPatientId}`,
    {
      headers: {},
    }
  );
});

const [
  getImportantNotes,
  useGetImportantNotes,
] = dataFetchHelper(([patientId]) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile/important-notes?patientId=${sanitizedPatientId}`,
    {
      headers: {},
    }
  );
});

const [
  getPatientProfileCareOpps,
  useGetPatientProfileCareOpps,
] = dataFetchHelper(([patientId]) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/care-gaps/patient-profile?patientId=${sanitizedPatientId}`,
    {
      headers: {},
    }
  );
});

const [getPatientProfileSuspects, useGetPatientProfileSuspects] = dataFetchHelper(
  ([patientId]) => {
    const sanitizedPatientId = encodeURIComponent(patientId);
    return axios.get(
      `${process.env.REACT_APP_REST_API_BASE_URL}/v1/rafs/patient-profile?patientId=${sanitizedPatientId}`,
      {
        headers: {},
      }
    );
  }
);

const [getPatientCard, useGetPatientCard] = dataFetchHelper(
  ([patientId]) => {
    const sanitizedPatientId = encodeURIComponent(patientId);
    return axios.get(
      `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patients/card-summary?patientId=${sanitizedPatientId}`,
      {
        headers: {},
      }
    );
  }
);

const [getPatientProfileADTs, useGetPatientProfileADTs] = dataFetchHelper(
  ([patientId]) => {
    const sanitizedPatientId = encodeURIComponent(patientId);
    return axios.get(
      `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patients/adts?patientId=${sanitizedPatientId}`,
      {
        headers: {},
      }
    );
  }
);

const [
  getPatientProfileAppointments,
  useGetPatientProfileAppointments,
] = dataFetchHelper(([patientId]) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile/appointments?patientId=${sanitizedPatientId}`,
    {
      headers: {},
    }
  );
});

const [
  getPatientProfileReferrals,
  useGetPatientProfileReferrals,
] = dataFetchHelper(([patientId]) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile/referrals?patientId=${sanitizedPatientId}`,
    {
      headers: {},
    }
  );
});

const [getPatientProfileNotes, useGetPatientProfileNotes] = dataFetchHelper(
  ([patientId]) => {
    const sanitizedPatientId = encodeURIComponent(patientId);
    return axios.get(
      `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patients/notes?patientId=${sanitizedPatientId}`,
      {
        headers: {},
      }
    );
  }
);

const [getPatientProfileNotesCount, useGetPatientProfileNotesCount] = dataFetchHelper(
  ([patientId]) => {
    const sanitizedPatientId = encodeURIComponent(patientId);
    return axios.get(
      `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patients/notes-count?patientId=${sanitizedPatientId}`,
      {
        headers: {},
      }
    );
  }
);

const [
  getCareProviderPartialNameSearch,
  useGetCareProviderPartialNameSearch,
] = dataFetchHelper(([patientId, name]) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  const sanitizedName = encodeURIComponent(name);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/care-providers/partial-name?patientId=${sanitizedPatientId}&name=${sanitizedName}`,
    {
      headers: {},
    }
  );
});

const [getCareManagements, useGetCareManagements] = dataFetchHelper(
  ([patientId]) => {
    const sanitizedPatientId = encodeURIComponent(patientId);
    return axios.get(
      `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile/care-paths?patientId=${sanitizedPatientId}`,
      {
        headers: {},
      }
    );
  }
);

const saveCareManagement = (careManagement) => {
  return axios.post(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-care-management/save-care-managements`,
    careManagement,
    {
      headers: {},
    }
  );
};

const [
  getCareManagementAcceptanceTypes,
  useGetCareManagementAcceptanceTypes,
] = dataFetchHelper(() => {
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/constants/careManagementAcceptanceTypes`,
    {
      headers: {},
    }
  );
});

const [
  getCareManagementStatuses,
  useGetCareManagementStatuses,
] = dataFetchHelper(([newEnrollment]) => {
  const sanitizedNewEnrollment = encodeURIComponent(newEnrollment);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/constants/careManagementStatuses?newEnrollment=${sanitizedNewEnrollment}`,
    {
      headers: {},
    }
  );
});

const [
  getAllUsersForHeadOrganization,
  useGetAllUsersForHeadOrganization,
] = dataFetchHelper(() => {
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/user-profile/organization/tinNumber`,
    {
      headers: {},
    }
  );
});

const [
  getCareManagementPrograms,
  useGetCareManagementPrograms,
] = dataFetchHelper(([patientId, newEnrollment]) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  const sanitizedNewEnrollment = encodeURIComponent(newEnrollment);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-care-management/care-managements-programs?patientId=${sanitizedPatientId}&newEnrollment=${sanitizedNewEnrollment}`,
    {
      headers: {},
    }
  );
});

const [
  getCareManagementOverview,
  useGetCareManagementOverview,
] = dataFetchHelper(([patientId]) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-care-management/care-management-overview?patientId=${sanitizedPatientId}`,
    {
      headers: {},
    }
  );
});

const [
  getCareGap,
  useGetCareGap,
] = dataFetchHelper(([careGapId]) => {
  const sanitizedCareGapId = encodeURIComponent(careGapId);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/manage-gaps/single?id=${sanitizedCareGapId}`,
    {
      headers: {},
    }
  );
});

const [
  getCareGaps,
  useGetCareGaps,
] = dataFetchHelper(([careGapIds]) => {
  const sanitizedCareGapIds = encodeURIComponent(careGapIds);
  return axios.get(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/manage-gaps/multiple?id=${sanitizedCareGapIds}`,
    {
      headers: {},
    }
  );
});

const updateSingleCareGap = (careGap) => {
  return axios.post(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/manage-gaps/single`,
      careGap,
    {
      headers: {},
    }
  );
};

const updateMultipleCareGap = (careGaps) => {
  return axios.post(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/manage-gaps/multiple`,
      careGaps,
    {
      headers: {},
    }
  );
};

const loadPreventiveCareHistoryData = (patientId, setAllOpportunitiesFOrHist, setAllSuspectsForHist, baseURLPC) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  axios
    .post(`${baseURLPC}/find?patientId=${sanitizedPatientId}`, {
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      setAllOpportunitiesFOrHist(response.data.careGapsResponse?.careGapsHistory || []);
      setAllSuspectsForHist(response.data.conditionsResponse?.conditionsHistory || []);
    })
    .catch((error) => {
    });
};

const printOverviewAction = (criteria, thenTask, catchTask) => {
  axios
    .post(PRINT_URL, criteria, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      thenTask(response);
    })
    .catch((error) => {
      catchTask(error);
    });
}

const exportSummaryOverviewAction = (thenTask, catchTask) => {
  axios
    .get(SUMMARY_URL, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      thenTask(response);
    })
    .catch((error) => {
      catchTask(error);
    });
}

const preventiveCareCountAction = (patientId, thenTask) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  axios.get(`${PREVENTIVE_CARE_COUNT_URL}?patientId=${sanitizedPatientId}`, {
    headers: {
      "Content-Type": "application/json"
    },
  })
    .then((response) => {
      thenTask(response);
    })
    .catch((error) => {
    });
}

const getLatestReferralAction = (patientId, thenTask) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  axios.get(`${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile/latestReferral?patientId=${sanitizedPatientId}`, {
    headers: {
      "Content-Type": "application/json"
    },
  })
    .then((response) => {
      thenTask(response);
    })
    .catch((error) => {
    });
}

const getLatestAdtAction = (patientId, thenTask) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  axios.get(`${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile/latest-adt?patientId=${sanitizedPatientId}`, {
    headers: {
      "Content-Type": "application/json"
    },
  })
    .then((response) => {
      thenTask(response);
    })
    .catch((error) => {
    });
}

const getPatientProfileOverviewCards = (patientId, thenTask) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  axios.get(`${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile/overview-cards?patientId=${sanitizedPatientId}`, {
    headers: {
      "Content-Type": "application/json"
    },
  })
    .then((response) => {
      thenTask(response);
    })
    .catch((error) => {
    });
}

const getExportPatientAssessments = (patientId, answerSetId, thenTask) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  const sanitizedAnswerSetId = encodeURIComponent(answerSetId);
  axios.get(`${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile/assessment-report?patientId=${sanitizedPatientId}&answerSetId=${sanitizedAnswerSetId}`, {
    headers: {
      "Content-Type": "application/json"
    },
  })
    .then((response) => {
      thenTask(response);
    })
    .catch((error) => {
    });
}

const postReportExtract = (patientId, thenTask) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  axios.post(`${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile/report-extract?patientId=${sanitizedPatientId}`, {
    headers: {
      "Content-Type": "application/json"
    },
  })
    .then((response) => {
      thenTask(response);
    })
    .catch((error) => {
    });
}

const findHistory = (patientId, body, thenTask, catchTask) => {
  const sanitizedPatientId = encodeURIComponent(patientId);
  axios.post(`${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-profile/history?patientId=${sanitizedPatientId}`, body, {
    headers: {
      "Content-Type": "application/json"
    },
  })
    .then((response) => {
      thenTask(response);
    })
    .catch((error) => {
      catchTask(error);
    });
}

const getRecommendedTeams = (thenTask) => {
  axios.get(`${process.env.REACT_APP_REST_API_BASE_URL}/v1/care-management/recommended-teams`, {
    headers: {
      "Content-Type": "application/json"
    },
  })
      .then((response) => {
        thenTask(response);
      })
      .catch((error) => {
      });
}

export {
  findHistory,
  postReportExtract,
  getExportPatientAssessments,
  getPatientProfileOverviewCards,
  getLatestAdtAction,
  getLatestReferralAction,
  preventiveCareCountAction,
  printOverviewAction,
  exportSummaryOverviewAction,
  getPatientProfileOverview,
  useGetPatientProfileOverview,
  getPatientProfileOverviewTabHeaderCount,
  useGetPatientProfileOverviewTabHeaderCount,
  getPatientProfileRecentActivity,
  useGetPatientProfileRecentActivity,
  getImportantNotes,
  useGetImportantNotes,
  getPatientProfileCareOpps,
  useGetPatientProfileCareOpps,
  getPatientProfileSuspects,
  useGetPatientProfileSuspects,
  getPatientCard,
  useGetPatientCard,
  getPatientProfileADTs,
  useGetPatientProfileADTs,
  getPatientProfileAppointments,
  useGetPatientProfileAppointments,
  getPatientProfileReferrals,
  useGetPatientProfileReferrals,
  getPatientProfileNotes,
  useGetPatientProfileNotes,
  getCareProviderPartialNameSearch,
  useGetCareProviderPartialNameSearch,
  updatePatientProfileOverview,
  patientInformationSection,
  getCareManagements,
  useGetCareManagements,
  saveCareManagement,
  getCareManagementAcceptanceTypes,
  useGetCareManagementAcceptanceTypes,
  getCareManagementStatuses,
  useGetCareManagementStatuses,
  getAllUsersForHeadOrganization,
  useGetAllUsersForHeadOrganization,
  getCareManagementPrograms,
  useGetCareManagementPrograms,
  getCareManagementOverview,
  useGetCareManagementOverview,
  getCareGap,
  useGetCareGap,
  getCareGaps,
  useGetCareGaps,
  getPatientProfileNotesCount, 
  useGetPatientProfileNotesCount,
  updateSingleCareGap,
  updateMultipleCareGap,
  loadPreventiveCareHistoryData,
  getRecommendedTeams
};
